import { FC } from 'react';
import UserDetail from './UserDetail';
import UseUserDetail from './UseUserDetail';

const UserDetailContainer: FC = () => {
  return <UserDetail {...UseUserDetail()} />;
};

export default UserDetailContainer;
